<template>
  <div>
    <div class="title">
      {{ orderDetails.reference }}
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    computed: {
      orderDetails() {
        return this.$store.getters.orderDetails
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
